import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Stack,
  Divider,
  Button,
  SvgIcon,
} from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import DescriptionIcon from "@mui/icons-material/Description";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { clearListuser, listUser } from "../../Redux/Slices/User/ListUserSlice";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { useLocation, useNavigate } from "react-router-dom";
import Menus from "../../Components/Menu/Menu";
import IconButtonField from "../../Components/Button/IconButtonField";
import styles from "../Mockexampage/MockGrid.module.scss";
import Avatars from "../../Components/Avatar/Avatars";
import { listSubjectNote } from "../../Redux/Slices/StudyNote/SubjectStudyNode";
import Mockexamimage from "../Mockexampage/Imagemockexampage/MockExamimage.jpg";
import { listListSubjectNoteTopicSlice } from "../../Redux/Slices/StudyNote/TopicStudyNode";
import { listListSubjectNoteContentSlice } from "../../Redux/Slices/StudyNote/TopicStudyNodeContent";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ReactComponent as Skilltrainer } from "../../Assets/Images/skilltrainer.svg";
import { ReactComponent as StudyNote } from "../../Assets/Images/study_note.svg";

import "./Content.scss";
const Content = () => {
  const { state: subtopicidcontent } = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (subtopicidcontent) {
      dispatch(listUser());
      dispatch(
        listListSubjectNoteContentSlice({ subtopic_id: subtopicidcontent })
      );
    }
  }, [dispatch, subtopicidcontent]);

  const { data: ListSubjectNoteContent } = useAppSelector(
    (state) => state.ListSubjectNoteContentSlice
  );
  const NoteContent: any = ListSubjectNoteContent?.data;

  const { data: ListUserSliceLoading } = useAppSelector(
    (state) => state.ListUserSlice
  );

  const ListUser: any = Array.isArray(ListUserSliceLoading?.data)
    ? ListUserSliceLoading?.data.map((user, index) => ({
        ...user,
        index: index + 1,
      }))
    : [];

  // html convert to

  const examples =
    Array.isArray(NoteContent) && NoteContent.length > 0
      ? NoteContent[0].examples ?? []
      : [];

  const handlePrevious = () => {
    setCurrentIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => Math.min(prev + 1, examples.length - 1));
  };

  const handlePageClick = (index: number) => {
    setCurrentIndex(index);
  };

  const currentExample = examples[currentIndex];

  if (!examples.length) {
    return (
      <Typography variant="h6" align="center" mt={4}>
        No content available.
      </Typography>
    );
  }

  return (
    <div className="ExamprocessStudentAlingment">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <Box display="flex" alignItems="center" gap={2}>
          <Typography
            onClick={() => {
              navigate(-1);
            }}
            // onClick={() => navigate("/topic")}
            sx={{
              color: "#007bff",
              cursor: "pointer",
              fontWeight: 500,
              fontSize: "14px",
            }}
          >
            <ArrowBackIcon sx={{ verticalAlign: "middle", mr: 0.5 }} />
            {/* Back to {NoteContent[0]?.subtopic} */}
            Back to SubTopices
          </Typography>
        </Box>
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <div>
            <Menus
              menuItems={[
                // {
                //   menu: "Profile",
                //   onClick: () => {
                //     nav("/studentprofile");
                //   },
                // },
                {
                  menu: "Logout",
                  onClick: () => {
                    sessionStorage.clear();
                    dispatch(clearListuser());
                    dispatch(clearLoginStatus());
                    navigate("/login");
                  },
                },
              ]}
            >
              <IconButtonField onClick={() => {}}>
                <Avatars sx={{ height: "2rem", width: "2rem" }} />
              </IconButtonField>
            </Menus>
            <span className="Username">{ListUser[0]?.student_name}</span>
          </div>
        </div>
      </div>
      <div>
        <Box
          ml={3}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
          gap={"5px"}
        >
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            {NoteContent[0]?.name}
          </Typography>
          <Typography variant="h5" sx={{ color: "gray", fontSize: "16px" }}>
            {NoteContent[0]?.description}
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Stack direction="row" spacing={0.5} alignItems="center">
              <Typography
                variant="body2"
                fontWeight="bold"
                sx={{
                  backgroundColor: "#F1F5F9",
                  px: 1,
                  py: 0.5,
                  borderRadius: 1,
                  fontSize: "12px",
                  display: "flex",
                  gap: "6px",
                }}
              >
                <AccessTimeIcon fontSize="small" />
                {NoteContent[0]?.timing}
              </Typography>
            </Stack>
          </Box>
        </Box>
        {/* <Box display="flex" gap="5px" m={2}>
          <Button
            variant="outlined"
            disabled={currentIndex === 0}
            onClick={handlePrevious}
            sx={{ textTransform: "capitalize" }}
          >
            ⬅ Previous
          </Button>
          <Button
            variant="outlined"
            sx={{ textTransform: "capitalize" }}
            disabled={currentIndex === examples.length - 1}
            onClick={handleNext}
          >
            Next ➡
          </Button>
        </Box> */}
      </div>

      <Box maxWidth="800px" mx="auto" my={4}>
        <Card elevation={3} sx={{ borderRadius: "10px" }}>
          <CardContent>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                fontWeight: 600,
                color: "black",
                display: "flex",
                gap: "10px",
                fontSize: "22px", // Increased by 2
                alignItems: "center",
              }}
            >
              <SvgIcon
                sx={{ color: "#2563eb", fontSize: "24px", fill: "none" }}
                component={StudyNote}
                inheritViewBox
              />{" "}
              Study Note
            </Typography>
            <div
              dangerouslySetInnerHTML={{ __html: NoteContent[0]?.content }}
              style={{
                fontFamily: "Arial, sans-serif",
                lineHeight: "1.6",
                fontSize: "18px",
              }} // Increased by 2
            />
          </CardContent>
        </Card>
      </Box>
      <Box maxWidth="800px" mx="auto" my={4} paddingBottom={"30px"}>
        <Card elevation={3} sx={{ borderRadius: "10px" }}>
          <CardContent>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                fontWeight: 600,
                color: "black",
                display: "flex",
                gap: "10px",
                fontSize: "22px", // Increased by 2
                alignItems: "center",
              }}
            >
              <SvgIcon
                sx={{ color: "#2563eb", fontSize: "24px", fill: "none" }}
                component={StudyNote}
                inheritViewBox
              />{" "}
              Example {currentIndex + 1}
            </Typography>
            <div
              dangerouslySetInnerHTML={{ __html: currentExample?.example }}
              style={{
                fontFamily: "Arial, sans-serif",
                lineHeight: "1.6",
                fontSize: "180px",
              }} // Increased by 2
            />
          </CardContent>
          <Box display="flex" justifyContent="space-between" m={2}>
            <Button
              variant="outlined"
              disabled={currentIndex === 0}
              onClick={handlePrevious}
              sx={{
                textTransform: "capitalize",
                minWidth: "85px",
                height: "35px",
                top: "10px",
              }}
            >
              ⬅ Previous
            </Button>

            <Box
              display={"flex"}
              overflow={"scroll"}
              maxWidth={"420px"}
              height={"48px"}
              padding={"9px"}
            >
              {examples?.map((_: any, index: number) => (
                <Button
                  className="example_pageination"
                  key={index}
                  variant={index === currentIndex ? "contained" : "outlined"}
                  onClick={() => handlePageClick(index)}
                  sx={{
                    color: index === currentIndex ? "#ffff" : "#009dff",
                  }}
                >
                  {index + 1}
                </Button>
              ))}
            </Box>
            <Button
              variant="outlined"
              sx={{
                textTransform: "capitalize",
                minWidth: "85px",
                height: "35px",
                top: "10px",
              }}
              disabled={currentIndex === examples.length - 1}
              onClick={handleNext}
            >
              Next ➡
            </Button>
          </Box>
        </Card>
      </Box>
    </div>
  );
};

export default Content;
